const BACKGROUND_COLOR = "BACKGROUND_COLOR";
const FOREGROUND_COLOR = "FOREGROUND_COLOR";
const TEXT_COLOR_TOOLBAR_BUTTON = "TextColorButton";
const TEXT_HIGHLIGHT_TOOLBAR_BUTTON = "TextHighlightButton";
export {
  BACKGROUND_COLOR,
  FOREGROUND_COLOR,
  TEXT_COLOR_TOOLBAR_BUTTON,
  TEXT_HIGHLIGHT_TOOLBAR_BUTTON
};
//# sourceMappingURL=dataHooks.js.map
